import { ApiMethod } from '../types/api.types';
import { workspaceParamsSchema } from '../types/payloads/workspace.payload';
import { apiKeyParamsSchema } from '../types/api-key.types';
import { apiKeyCreationResponse, apiKeyListResponse } from '../types/responses/api-key.responses';
import { apiKeyCreationBodySchema } from '../types/payloads/api-key.payload';
import { workspaceAcl } from '../utils/acl';

export const API_KEY_API = {
    LIST: {
        method: ApiMethod.GET,
        path: '/workspaces/:workspaceName/api-keys',
        handlerMethod: 'listApiKeys',
        workspaceRoles: workspaceAcl.workspaces.manage,
        zod: {
            params: workspaceParamsSchema
        },
        responses: {
            200: {
                description: 'The workspace API keys',
                schema: apiKeyListResponse
            }
        }
    },
    POST: {
        method: ApiMethod.POST,
        path: '/workspaces/:workspaceName/api-keys',
        handlerMethod: 'createApiKey',
        workspaceRoles: workspaceAcl.workspaces.manage,
        zod: {
            params: workspaceParamsSchema,
            body: apiKeyCreationBodySchema
        },
        responses: {
            200: {
                description: 'The created API key',
                schema: apiKeyCreationResponse
            }
        }
    },
    DELETE: {
        method: ApiMethod.DELETE,
        path: '/workspaces/:workspaceName/api-keys/:apiKeyUuid',
        handlerMethod: 'deleteApiKey',
        workspaceRoles: workspaceAcl.workspaces.manage,
        zod: {
            params: apiKeyParamsSchema
        },
        responses: {
            204: {
                description: 'The API key was successfully deleted'
            }
        }
    }
} as const;
